import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Badge';
import useMessagesStatsContext from 'Context/MessagesStatsContext';

const MessagesBadge = ({ children, className }) => {
  const { unreadThreadCount } = useMessagesStatsContext();

  return unreadThreadCount > 0
    ? (
      <Badge className={className} badgeContent={unreadThreadCount} test="nav-messages-unread-badge">
        {children}
      </Badge>
    )
    : children;
};

MessagesBadge.defaultProps = {
  children: null,
  className: '',
};
MessagesBadge.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default MessagesBadge;
